// @flow

import { action } from "mobx";

import Store from "app/stores/Store";
import VideoStore from "app/stores/VideoStore";
import VideoShareStore from "app/stores/VideoShareStore";

class StatsStore extends Store {
    get url(): string {
        const video = VideoStore.video;
        const time = VideoShareStore.time;

        let url =
            window.location.origin +
            "/watch?tlv=" +
            video.uid +
            "&r=" +
            video.version;
        if (time) url += `&st=${time}`;

        return url;
    }

    @action.bound shareVideo() {
        this.track("shared-video", { url: this.url });
    }

    @action.bound shareVideoHow(type) {
        this.track("shared-video-how", { url: this.url, type });
    }
}

export default new StatsStore();



// WEBPACK FOOTER //
// ./src/app/stores/StatsStore.js